"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highchart = exports.useHighchart = exports.HighchartVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const merge_1 = __importDefault(require("lodash/merge"));
const highcharts_1 = __importDefault(require("highcharts"));
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const theme_1 = require("../../themes/typings/theme");
const Chart_1 = require("./Chart");
const __DEV__ = process.env.NODE_ENV !== 'production';
var HighchartVariants;
(function (HighchartVariants) {
    HighchartVariants["DEFAULT"] = "default";
})(HighchartVariants || (exports.HighchartVariants = HighchartVariants = {}));
const HighchartContext = (0, react_1.createContext)({
    options: {},
});
const useHighchart = () => (0, react_1.useContext)(HighchartContext);
exports.useHighchart = useHighchart;
const constructOptions = (options) => {
    var _a, _b, _c, _d, _e;
    return {
        legend: {
            enabled: (_a = options.legend) === null || _a === void 0 ? void 0 : _a.enabled,
        },
        plotOptions: {
            series: {
                lineWidth: options.lineWidth,
            },
        },
        title: {
            text: options.title,
        },
        xAxis: {
            labels: {
                enabled: (_b = options.xAxis) === null || _b === void 0 ? void 0 : _b.enabled,
            },
            title: {
                text: (_c = options.xAxis) === null || _c === void 0 ? void 0 : _c.title,
            },
        },
        yAxis: {
            labels: {
                enabled: (_d = options.yAxis) === null || _d === void 0 ? void 0 : _d.enabled,
            },
            title: {
                text: (_e = options.yAxis) === null || _e === void 0 ? void 0 : _e.title,
            },
        },
        navigation: {
            buttonOptions: {
                enabled: options.exportButton,
            },
        },
    };
};
const getVariantOptions = (theme, variant) => {
    switch (variant) {
        default:
            return {
                accessibility: {
                    enabled: true,
                },
                chart: {
                    backgroundColor: theme.colors.$background100,
                    style: {
                        fontFamily: theme.font.$primaryFont,
                    },
                },
                colors: [
                    theme.colors.$secondary300,
                    theme.colors.$primary100,
                    theme.colors.$accent100,
                    theme.colors.$accent200,
                ],
                credits: {
                    enabled: false,
                },
                legend: {
                    enabled: false,
                    itemStyle: Object.assign(Object.assign({}, theme.typography.$textSubtext150), { color: theme.colors.$content100 }),
                },
                plotOptions: {
                    series: {
                        lineWidth: 4,
                        marker: {
                            enabled: false,
                        },
                        states: {
                            hover: {
                                lineWidthPlus: 0,
                            },
                        },
                    },
                },
                title: {
                    align: 'left',
                    style: Object.assign(Object.assign({}, theme.typography.$textPrimary200), { color: theme.colors.$content100 }),
                },
                tooltip: {
                    backgroundColor: theme.__base === theme_1.GlobalBaseTheme.DARK ? theme.colors.$background200 : theme.colors.$neutral100,
                    borderColor: theme.colors.$primary200,
                    borderRadius: 4,
                    borderWidth: 1,
                    shared: true,
                    style: Object.assign({}, theme.typography.$textSecondary000),
                    useHTML: true,
                },
                xAxis: {
                    crosshair: {
                        color: theme.colors.$primary200,
                        dashStyle: 'Dash',
                        width: 1,
                    },
                    labels: {
                        enabled: false,
                        style: Object.assign(Object.assign({}, theme.typography.$textPrimary025), { color: theme.colors.$content100 }),
                    },
                    title: {
                        style: Object.assign(Object.assign({}, theme.typography.$textPrimary025), { color: theme.colors.$content100 }),
                    },
                    lineWidth: 0,
                    tickLength: 0,
                },
                yAxis: {
                    labels: {
                        enabled: false,
                        style: Object.assign(Object.assign({}, theme.typography.$textPrimary025), { color: theme.colors.$content100 }),
                    },
                    gridLineWidth: 0,
                    title: {
                        style: Object.assign(Object.assign({}, theme.typography.$textPrimary025), { color: theme.colors.$content100 }),
                    },
                },
                exporting: {
                    buttons: {},
                },
                navigation: {
                    buttonOptions: {
                        enabled: false,
                    },
                    menuStyle: {
                        backgroundColor: theme.colors.$background100,
                        fontFamily: theme.font.$primaryFont,
                    },
                },
            };
    }
};
const Highchart = (props) => {
    // Import modules when Highcharts is called
    require('highcharts/modules/accessibility')(highcharts_1.default);
    require('highcharts/modules/export-data')(highcharts_1.default);
    require('highcharts/modules/exporting')(highcharts_1.default);
    require('highcharts/modules/offline-exporting')(highcharts_1.default);
    require('highcharts/modules/pattern-fill')(highcharts_1.default);
    const { rawOptions = {}, variant = HighchartVariants.DEFAULT, options = {}, data, children } = props;
    const theme = (0, ThemeProvider_1.useTheme)();
    if (!theme) {
        if (__DEV__) {
            console.error('`Highchart` component must be a child of a `ThemeProvider`');
        }
        return null;
    }
    const value = (0, react_1.useMemo)(() => ({
        options: (0, merge_1.default)(getVariantOptions(theme, variant), constructOptions(options), rawOptions, {
            series: data,
        }),
    }), [options, rawOptions, variant]);
    return (0, jsx_runtime_1.jsx)(HighchartContext.Provider, { value: value, children: children });
};
exports.Highchart = Highchart;
Highchart.Chart = react_1.default.forwardRef((props, ref) => (0, jsx_runtime_1.jsx)(Chart_1.Chart, Object.assign({}, props, { ref: ref })));
